<div class="filters">
  <mat-form-field
    appearance="outline"
    class="date-wrapper"
  >
    <mat-label>Период</mat-label>
    <mat-date-range-input
      [formGroup]="rangeForm"
      [rangePicker]="picker"
    >
      <input
        #dateRangeStart
        matInput
        matStartDate
        appDateInput
        placeholder="Начальная"
        formControlName="dateFrom">

      <input
        #dateRangeEnd
        matInput
        matEndDate
        appDateInput
        placeholder="Конечная"
        formControlName="dateTo"
        (dateChange)="handleDateRangeChange(dateRangeStart.value, dateRangeEnd.value)"
      >
    </mat-date-range-input>
    <div class="toggle">
      <mat-datepicker-toggle
        matIconSuffix
        [for]="picker"
      ></mat-datepicker-toggle>
      <mat-datepicker-toggle
        matSuffix
        (click)="clearDateRange()"
      >
        <mat-icon matDatepickerToggleIcon>clear</mat-icon>
      </mat-datepicker-toggle>
    </div>
    <mat-date-range-picker #picker></mat-date-range-picker>
  </mat-form-field>
  <app-custom-mat-select
    label="Маркетплейс"
    [options]="marketplacesSelectData"
    (selectedChange)="handleSelectChange($event, 'channelType')"
  />
  <app-custom-mat-select
    label="Артикул"
    [options]="articlesSelectData"
    (selectedChange)="handleSelectChange($event, 'article')"
  />
</div>
